import envConfig from './env'

const ASCII_ART = `
███████╗██╗   ██╗███╗   ██╗ ██████╗ ██████╗ 
██╔════╝╚██╗ ██╔╝████╗  ██║██╔═══██╗██╔══██╗
███████╗ ╚████╔╝ ██╔██╗ ██║██║   ██║██████╔╝
╚════██║  ╚██╔╝  ██║╚██╗██║██║   ██║██╔═══╝ 
███████║   ██║   ██║ ╚████║╚██████╔╝██║     
╚══════╝   ╚═╝   ╚═╝  ╚═══╝ ╚═════╝ ╚═╝     
`

function formatVersion() {
  const shortSha = envConfig.appVersion.slice(0, 7)
  if (!shortSha) return ''

  const date = envConfig.buildTimestamp ? envConfig.buildTimestamp.slice(0, 10) : ''
  const version = date ? `${shortSha} (${date})` : shortSha
  return `build version: ${version}`
}

export default function logAppVersion() {
  if (typeof window === 'undefined') return

  const version = formatVersion()
  console.log(version ? ASCII_ART + '\n' + version : ASCII_ART)
}
